export enum DemographicsTypeId {
  CustomerEmailAddress = 3,
  CustomerPhoneNumber = 4,
  CustomerType = 155,
  Channel = 171,
  CustomerName = 173,
  CustomerNumber = 175,
  InteracteeName = 209,
  SurveyName = 213,
  InteractionEventID = 217,
  InteractionEventDate = 219,
  InteractionEventTime = 221,
  EventNo = 225,
  EventReasonDescription = 227,
  HighestPrincipalPackage = 231,
  ScheduledEventDate = 233,
  InteractionEventDateTime = 235,
  EventDescription = 237,
  InteractionEventFlag = 261,
  InteractionCategory = 265,
  InteractionSubCategory = 267,
  InteractionOutcome = 269,
  CommunicationMethodDesc = 277,
  PreferredLanguageDesc = 279,
  AgeOfCustomer = 289,
  AgeOfAccount = 295,
  NoOfDecoders = 297,
  NoOfDCCPolicies = 299,
  InteractionAgentFullName = 303,
  MethodOfPaymentName = 313,
  NextInvoiceDate = 315,
  PaymentPoint = 317,
  TouchPoint = 319,
  InteractionEventChannel = 325,
  CustomerRegion = 327,
  CustomerStatusDesc = 333,
  CustomerClassDesc = 335,
  CustomerAccountType = 337,
  CustomerAccountStatus = 339,
  InteractionAgentEmailAddress = 345,
  InteractionAgentSupervisorDesc = 347,
  InteractionAgentDutyManagerDesc = 349,
  InteractionAgentDepartment = 353,
  InteractionAgentAgencyName = 355,
  FinancialProductType = 359,
  FinancialProductName = 361,
  InstallerName = 363,
  InteracteeTelephoneNumber = 365,
  InteractionAgentContactCentreManagerDesc = 367,
  InteractionAgentADAccountFullName = 369,
  DecoderTypeUsed = 460,
  HasUsedDStvNow = 465,
  HasUsedConnectedExplora = 468,
  HasUsedSuperSport = 474,
  HasUsedBoxOffice = 475,
  Journey = 520,
  Brand = 523,
  StatusBeforePay = 526,
  OptOutMessage = 529,
  Country = 532,
  Unknown = 545,
}

export enum MAHDemographicsTypeId {
  Country = 334,
  InteractionEventID = 339,
  InteractionEventFlag = 342,
  InteractionEventDate = 345,
  ScheduledEventDate = 348,
  InteractionEventTime = 351,
  InteractionEventDateTime = 354,
  InteracteeName = 357,
  InteracteeTelephoneNumber = 360,
  InteractionCategory = 363,
  InteractionSubCategory = 366,
  InteractionOutcome = 369,
  InteractionEventChannel = 372,
  EventNo = 375,
  EventDescription = 378,
  EventReasonDescription = 381,
  SurveyName = 384,
  CustomerNumber = 387,
  CustomerName = 390,
  CustomerRegion = 15,
  CustomerType = 396,
  CommunicationMethodDesc = 399,
  PreferredLanguageDesc = 402,
  CustomerEmailAddress = 3,
  CustomerPhoneNumber = 4,
  CustomerStatusDesc = 405,
  CustomerClassDesc = 408,
  AgeOfCustomer = 411,
  CustomerAccountType = 414,
  CustomerAccountStatus = 417,
  AgeOfAccount = 420,
  HighestPrincipalPackage = 423,
  NoOfDecoders = 426,
  NoOfDCCPolicies = 429,
  InteractionAgentADAccountFullName = 432,
  InteractionAgentFullName = 435,
  InteractionAgentEmailAddress = 438,
  InteractionAgentSupervisorDesc = 441,
  InteractionAgentDutyManagerDesc = 444,
  InteractionAgentContactCentreManagerDesc = 447,
  InteractionAgentDepartment = 450,
  InteractionAgentAgencyName = 453,
  MethodOfPaymentName = 456,
  NextInvoiceDate = 459,
  PaymentPoint = 462,
  FinancialProductType = 465,
  FinancialProductName = 468,
  InstallerName = 471,
  Journey = 474,
  Brand = 477,
  Channel = 480,
  TouchPoint = 483,
  StatusBeforePay = 486,
  OptOutMessage = 511,
  MAHRegion = 527,
}

export enum GenexSurveyTypes {
  None = '',
  Genex = 'DStv_genex',
  GenexMAH = 'DStv_genex_mah',
}

//Used for category
export enum GenexActions {
  None = '',
  AccessMailbox = 'Access Mailbox',
  AccessOrClaimRewards = 'Access or Claim Rewards',
  AccessTVGuide = 'Access TV guide',
  AddMovies = 'Add Movies',
  ClearFixDecoderErrors = 'Clear/fix decoder errors',
  DecoderInsurance = 'Decoder Insurance',
  LinkPackageActivate = 'Link Package (activate)',
  PayMyAccount = 'Pay my account',
  PersonalizedViewingRecomEngine = 'Personalized viewing (Recom engine)',
  ReconnectMyPackage = 'Reconnect my package',
  SetUpMyHolidayViewing = 'Set up my holiday viewing',
  ShowmaxLinking = 'Showmax Linking',
  StreamingOnboarding = 'Streaming onboarding',
  UpdateAccountDetails = 'Update Account details',
  UpgradeDowngradeSubscription = 'Upgrade/downgrade my subscription',
  LiveChat = 'LiveChat',
  BoxOfficeRent = 'Box Office Rent',
  DisconnectPackage = 'Disconnect Package',
  RecurringPaymentSetup = 'Recurring Payment Set Up',
  RecurringPaymentUpdate = 'Update Recurring Payment',
  RecurringPaymentCancel = 'Cancelling Recurring Payment',
}

export enum CsatActions {
  None = 'None',
  Pay = 'Pay',
  BoxofficeRent = 'BoxofficeRent',
  ChangePackage = 'ChangePackage',
  Reconnect = 'Reconnect',
  UpdateDetails = 'UpdateDetails',
  Rewards = 'Rewards',
  LiveChat = 'LiveChat',
  Showmax = 'Showmax',
  ShowmaxActivate = 'ShowmaxActivate',
  ShowmaxActivatePRM = 'ShowmaxActivatePRM',
  ShowmaxHelpActivate = 'ShowmaxHelpActivate',
  ShowmaxSurvey = 'ShowmaxSurvey',
  FixError = 'FixError',
  FixErrorContact = 'FixErrorContact',
  FixErrorCustomer = 'FixErrorCustomer',
  FixErrorInstaller = 'FixErrorInstaller',
  RecurringPaymentSetup = 'RecurringPaymentSetup',
  RecurringPaymentUpdate = 'RecurringPaymentUpdate',
  RecurringPaymentCancel = 'RecurringPaymentCancel',
}

//Used for survey name
export const ActionCodes = {
  //Accepted Genex survey types.
  [CsatActions.None]: '',
  [CsatActions.Pay]: 'Payment',
  [CsatActions.BoxofficeRent]: 'DSTVBOXOFFICERENT',
  [CsatActions.ChangePackage]: 'ChangePackage',
  [CsatActions.UpdateDetails]: 'UpdateDetails',
  [CsatActions.Reconnect]: 'Reconnect',
  [CsatActions.Rewards]: 'DSTVREWARDS',
  [CsatActions.LiveChat]: 'LiveChat',
  [CsatActions.Showmax]: 'DSTVSHOWMAX',
  [CsatActions.ShowmaxActivate]: 'DSTVSHOWMAXACTIVE',
  [CsatActions.ShowmaxActivatePRM]: 'DSTVSHOWMAXACTIVEPRM',
  [CsatActions.ShowmaxHelpActivate]: 'HELPDEACTIVATESHOWMAX',
  [CsatActions.ShowmaxSurvey]: 'DSTVSHOWMAXSURVEY ',
  [CsatActions.FixError]: 'DSTVFIXERRORCUSTOMER',
  [CsatActions.FixErrorContact]: 'DSTVFIXERRORCONTACT',
  [CsatActions.FixErrorCustomer]: 'DSTVFIXERRORCUSTOMER',
  [CsatActions.FixErrorInstaller]: 'DSTVFIXERRORINSTALLER',
  [CsatActions.RecurringPaymentSetup]: 'Recurring Payment Set Up',
  [CsatActions.RecurringPaymentUpdate]: 'Update Recurring Payment',
  [CsatActions.RecurringPaymentCancel]: 'Cancelling Recurring Payment',
};

export const PortugueseActionCodes = {
  //Accepted GetFeedback survey types.
  [CsatActions.None]: '',
  [CsatActions.Pay]: 'DSTVPAYNOW_PT',
  [CsatActions.BoxofficeRent]: 'DSTVBOXOFFICERENT_PT',
  [CsatActions.ChangePackage]: 'DSTVCHANGEPACKAGE_PT',
  [CsatActions.UpdateDetails]: 'DSTVUPDATEDETAILS_PT',
  [CsatActions.Reconnect]: 'Reconnect_PT',
  [CsatActions.Rewards]: 'DSTVREWARDS',
  [CsatActions.LiveChat]: 'DSTVLIVECHAT_PT',
  [CsatActions.Showmax]: 'DSTVSHOWMAX',
  [CsatActions.ShowmaxActivate]: 'DSTVSHOWMAXACTIVE',
  [CsatActions.ShowmaxActivatePRM]: 'DSTVSHOWMAXACTIVEPRM',
  [CsatActions.ShowmaxHelpActivate]: 'HELPDEACTIVATESHOWMAX',
  [CsatActions.ShowmaxSurvey]: 'DSTVSHOWMAXSURVEY ',
  [CsatActions.FixError]: 'DSTVFIXERRORCUSTOMER_PT',
  [CsatActions.FixErrorContact]: 'DSTVFIXERRORCONTACT',
  [CsatActions.FixErrorCustomer]: 'DSTVFIXERRORCUSTOMER',
  [CsatActions.FixErrorInstaller]: 'DSTVFIXERRORINSTALLER_PT',
  [CsatActions.RecurringPaymentSetup]: 'RecurringPaymentSetup_PT',
  [CsatActions.RecurringPaymentUpdate]: 'RecurringPaymentUpdate_PT',
  [CsatActions.RecurringPaymentCancel]: 'RecurringPaymentCancel_PT',
};

export const GoTvActionCodes = {
  ...ActionCodes,
  [CsatActions.LiveChat]: 'GOTVLIVECHAT',
  [CsatActions.FixError]: 'GOTVFIXERRORCUSTOMER',
  [CsatActions.FixErrorContact]: 'GOTVFIXERRORCONTACT',
  [CsatActions.FixErrorCustomer]: 'GOTVFIXERRORCUSTOMER',
  [CsatActions.FixErrorInstaller]: 'GOTVFIXERRORINSTALLER',
  [CsatActions.RecurringPaymentSetup]: 'GOTV_RecurringPaymentSetup',
  [CsatActions.RecurringPaymentUpdate]: 'GOTV_RecurringPaymentUpdate',
  [CsatActions.RecurringPaymentCancel]: 'GOTV_RecurringPaymentCancel',
};

export const PortugueseGoTvActionCodes = {
  ...PortugueseActionCodes,
  [CsatActions.Pay]: 'GOTVPAYNOW_PT',
  [CsatActions.FixError]: 'GOTVFIXERRORCUSTOMER_PT',
  [CsatActions.ChangePackage]: 'GOTVCHANGEPACKAGE_PT',
  [CsatActions.UpdateDetails]: 'GOTVUPDATEDETAILS_PT',
  [CsatActions.LiveChat]: 'GOTVLIVECHAT_PT',
  [CsatActions.FixErrorContact]: 'GOTVFIXERRORCONTACT_PT',
  [CsatActions.FixErrorCustomer]: 'GOTVFIXERRORCUSTOMER_PT',
};
